export default [
  {
    name: "Bunsen",
    id: "bb432d58-f3ee-40d3-aa8d-fd28c4299945",
  },
  {
    name: "Mätglaset",
    id: "6f281671-33da-44b1-9c94-3455b3b2877e",
  },
  {
    name: "Bägaren",
    id: "70523c60-b250-4421-9304-7d8e308b9de2",
  },
  {
    name: "Lågan",
    id: "98deb62c-05ab-4900-aac9-e046497bc836",
  },
  {
    name: "Pillret",
    id: "ee9e58e7-ecdd-4ae0-bd67-5dc26ca2df53",
  },
  {
    name: "Öglan",
    id: "ea4bf742-e341-48ae-934e-415186cf9479",
  },
  {
    name: "Vågen",
    id: "65bd44ea-22cd-4b26-9058-15b37b1919b8",
  },
  {
    name: "Kolven",
    id: "e07d3fed-c067-42e7-adf5-7b50cf6bab0a",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house420.id
}))
 */
